package org.bsvac.bsvac_kmp.data.models

enum class CertificationModel {
    EMT,
    MVO,
    PARAMEDIC
}